import { Env } from '@Constants/BuildInfo';

export const StructureEditorsConst = {
  marvin: {
    name: 'marvin',
    title: 'MarvinJS',
    render: true,
    setting: 'SE_MARVIN',
  },
  chemdraw: {
    name: 'chemdraw',
    setting: 'SE_CHEMDRAW',
    title: 'ChemDrawJS',
  },
};

export const structureContainerIds = {
  quickSearch: 'qs-container',
  structureFilter: 'filter-container',
  zoomIn: 'zoom-in-container',
  popupStructure: 'popup-structure-container',
};

export const StructureFromNameOptions = {
  IS: {
    serverValue: 'soIs',
    viewValue: 'is',
  },
  STARTS_WITH: {
    serverValue: 'soStartsWith',
    viewValue: 'starts with',
  },
  ENDS_WITH: {
    serverValue: 'soEndsWith',
    viewValue: 'ends with',
  },
  CONTAINS: {
    serverValue: 'soContains',
    viewValue: 'contains',
  },
};

export const StructureFromNameTexts = {
  nameNotFoundMessage:
    'Cannot translate the name/ID you entered. Please check the spelling and try again. If the issue persists, then we may not be able to translate the name/ID. In such a case, please provide feedback.',
  nameNotFoundErrorMessage: 'Cannot translate the name/ID you entered. Please check the spelling and try again.',
  nameNotFoundInfoMessage: 'Some names and IDs may not be covered by translation yet. Please provide feedback to help us improve.',
  confirmText: 'OK',
};

export const StructureEditorConfig = {
  editor: `${Env.StructureEditorsHostUrl}/cdn/structure-editor/editorws.html`,
  optionsIds: {
    MORE: {
      id: 'more',
      title: 'More options',
      titleToggled: 'Fewer options',
    },
  },
  optionTypes: {
    checkbox: 'checkbox',
    radioButton: 'radio',
    select: 'select',
    input: 'input',
  },
  toolbar: {
    only3D: 'ws_view3d',
    basicSearch: 'basicReactionSearch',
    customSearch: 'Custom_Search',
  },
  unshowed: ['more', 'family', 'include'],
};

export const StructureEditorLazyLoadConfig = {
  cores: {
    chemdraw: [
      `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/chemdrawweb.js`,
      `${Env.StructureEditorsHostUrl}/cdn/chemdrawweb/bootstrap3-compatibility.css`,
    ],
  },
};
